import React, { useState, useRef, useEffect } from "react"
import Head from './../components/head'
import Layout from './../components/layout/layout'
import '../styles/index.scss'
import { dataHeaderLarge } from '../data/data-footer'
import logoBurger from '../assets/images/header/burger.svg'
import close from '../assets/images/header/close.png'
import logoBig from '../assets/images/logo-icon.png'
import './header.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import '../modules/homepage/Home.scss'
import bimg from "../assets/images/homepage/brush-home.png";
import bimg2 from "../assets/images/intro/brush-large.png";
import Loadable from "@loadable/component"
import scrollTo from 'gatsby-plugin-smoothscroll';

const HomepageMobile = Loadable(() => import("../modules/homepage/HomepageMobile"))
const IntroPageMobile = Loadable(() => import("../modules/intro/IntroPageMobile"))
const FunctionPageMobile = Loadable(() => import("../modules/function/FunctionPageMobile"))
const SystemPage = Loadable(() => import("../modules/system/SystemPage"))
const PricePage = Loadable(() => import("../modules/price/PricePage"))
const isBrowser = typeof window !== `undefined`
const IndexPage = () => {
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [scrollY, setScrollY] = useState(false);

  const [classBrush, setClassBrush] = useState(true)
  // smoothscroll.polyfill();
  useEffect(() => {
    if (scrollY > 0) {
      setClassBrush(false)
    }
    else setClassBrush(true)
  }, [scrollY])

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    // returned function will be called on component unmount 
    return () => {
      window.removeEventListener("scroll", handleScroll);
    }
  }, [])

  const handleScroll = () => {
    window.scrollY > 1
      ? setScrollY(true)
      : setScrollY(false)
  };
  const [width, setWidth] = useState(isBrowser && window.innerWidth);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {

    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }

  }, []);

  let isMobile = width < 768 ? true : false;
  const onOpenModal = () => {
    setIsOpenModal(true)
  }
  const onCloseModal = () => {
    setIsOpenModal(false)
  }
  const myRef1 = useRef(null)
  const myRef2 = useRef(null)
  const myRef3 = useRef(null)
  const myRef4 = useRef(null)
  const myRef5 = useRef(null)
  const divTop = useRef()

  const executeScroll2x = () => {
    setIsOpenModal(false)
    // window.scroll({
    //   behavior: 'smooth',
    //   top: myRef2.current.getBoundingClientRect().top + window.scrollY
    // })
    // scrollTo('#GioiThieu')
    myRef2.current.scrollIntoView({ behavior: 'smooth' })
  }

  const executeScroll3x = () => {
    setIsOpenModal(false)
    myRef3.current.scrollIntoView({ behavior: 'smooth' })
  }


  const executeScroll4x = () => {
    setIsOpenModal(false)
    myRef4.current.scrollIntoView({ behavior: 'smooth' })
  }


  const executeScroll5x = () => {
    setIsOpenModal(false)
    myRef5.current.scrollIntoView({ behavior: 'smooth' })
  }

  // function smoothScroll(target) {
  //   const { top } = target.getBoundingClientRect()
  //   window.scrollTo({
  //     top: top + window.pageYOffset,
  //     behavior: "smooth"
  //   });
  // }

  const handleCrollTop = (e) => {
    e.preventDefault();
    console.log("handleCrollTop")
    // smoothScroll(divTop.current)
    scrollTo('#ScrollTop')
  }

  const executeScroll2 = () => {
    myRef2.current.scrollIntoView({ behavior: 'smooth' })
  }
  const executeScroll3 = () => {
    myRef3.current.scrollIntoView({ behavior: 'smooth' })
  }
  const executeScroll4 = () => {
    myRef4.current.scrollIntoView({ behavior: 'smooth' })
  }
  const executeScroll5 = () => {
    myRef5.current.scrollIntoView({ behavior: 'smooth' })
  }

  const array = [executeScroll2, executeScroll3, executeScroll4, executeScroll5]

  const renderMobile = () => (
    <div>
      <div ref={myRef1}>
        <HomepageMobile />
      </div>
      <div ref={myRef2} >
        <IntroPageMobile />
      </div>
      <div >
        <FunctionPageMobile ref={myRef3} isMobile={isMobile} />
      </div>
      <div >
        <SystemPage ref={myRef4} />
      </div>
      <div ref={myRef5} className="hidden">
        <PricePage />
      </div>
    </div>
  )

  const mobileContent = () => (
    <>
      <div className={`headerNP-mobile ${scrollY ? 'bottom' : 'top'}`}>
        <div className={`container ${scrollY ? 'bottom' : 'top'}`}>
          <a onClick={handleCrollTop}>
            <img src={logoBig} alt="logo-nippon-paint" className={`headerNP-mobile-logo ${scrollY ? 'bottom' : 'top'}`} />
          </a>
          <div style={{ height: 40 }} onClick={() => onOpenModal()}>
            <img src={logoBurger} alt="logo-nippon-paint" className={`headerNP-mobile-burger ${scrollY ? 'bottom' : 'top'} `} />
          </div>
        </div>

      </div>
      <div className={`headerNP-mobile-modal ${isOpenModal ? 'show' : 'hide'}`}>

        <div onClick={onCloseModal} className="headerNP-mobile-modal-close-btn">
          <img src={close} alt="logo-nippon-paint" />
        </div>
        <div className="headerNP-mobile-modal-content">
          <div className='headerNP-mobile-modal-cover-link a' onClick={executeScroll2x}>
            <div className='headerNP-mobile-modal-normal'>
              {dataHeaderLarge[0]?.title}
            </div>

          </div>
          <div className='headerNP-mobile-modal-cover-link a' onClick={executeScroll3x}>
            <div className='headerNP-mobile-modal-normal'>
              {dataHeaderLarge[1]?.title}
            </div>
          </div>
          <div className='headerNP-mobile-modal-cover-link a' onClick={executeScroll4x}>
            <div className='headerNP-mobile-modal-normal'>
              {dataHeaderLarge[2]?.title}
            </div>
          </div>
          <div className='headerNP-mobile-modal-cover-link a hidden' onClick={executeScroll5x} >
            <div className='headerNP-mobile-modal-normal'>
              {dataHeaderLarge[3]?.title}
            </div>
          </div>
        </div>
      </div>

    </>
  )

  const desktopContent = () => {
    return (
      <div className={`headerNP-desktop ${scrollY ? 'bottom' : 'top'}`}>
        <div className={`container  ${scrollY ? 'bottom' : 'top'}`} >
          <a onClick={handleCrollTop}>
            <img src={logoBig} alt="logo-nippon-paint" className={`headerNP-desktop-logo ${scrollY ? 'bottom' : 'top'}`} />
          </a>
          <div className="headerNP-desktop-cover-text">
            {
              dataHeaderLarge.map((value, idx) => (
                <div key={idx} className={`headerNP-desktop-cover-link a ${scrollY ? 'bottom' : 'top'} ${value?.classEffect ? 'hidden' : ''}`}
                  onClick={array[idx]}>
                  <div className={`headerNP-desktop-normal ${scrollY ? 'bottom' : 'top'} ${value?.classEffect ? value?.classEffect : null}`}
                  >
                    {value?.title}
                    {value?.classEffect && <FontAwesomeIcon icon={faArrowRight} color="white" className="headerNP-desktop-normal arrow" />}
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    )
  }

  return (
    isBrowser && <React.Suspense fallback={<span>Loading...</span>}>
      <Layout isMobile={isMobile}>
        <Head title="Sơn Nippon Matex Sắc Màu Dịu Mát" />
        <div className="headerNP" ref={divTop} id="ScrollTop" >
          {isMobile ? mobileContent() : desktopContent()}
        </div>
        {renderMobile()}
        <div className={`homepage-mobile-brush ${classBrush ? 'top' : 'bottom'}`}>
          <img src={isMobile ? bimg : bimg2} alt="" />
        </div>
      </Layout>
    </React.Suspense>

  )
}

export default IndexPage
